// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"40e50f3f","234":"8629d521","940":"2ed3c13d"}[chunkId] + ".chunk.js";
};